import {
  FETCH_HEALTH_SPAN_PROFILE_REQUEST,
  FETCH_HEALTH_SPAN_PROFILE_SUCCESS,
  FETCH_HEALTH_SPAN_PROFILE_FAILURE,
  FETCH_HEALTH_SPAN_PROFILE_STATUS,
  CLEAR_HEALTH_SPAN_PROFILE,
} from '../actions/types';

const INITIAL_STATE = {
  profile: null,
  profileStatus: null,
  loading: false,
  error: null,
};

export default function healthSpanReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_HEALTH_SPAN_PROFILE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_HEALTH_SPAN_PROFILE_SUCCESS:
      return {
        ...state,
        profile: action.payload,
        profileStatus: 'ready',
        loading: false,
        error: null,
      };
    case FETCH_HEALTH_SPAN_PROFILE_STATUS:
      return {
        ...state,
        profileStatus: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_HEALTH_SPAN_PROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_HEALTH_SPAN_PROFILE:
      return INITIAL_STATE;
    default:
      return state;
  }
}
